export default "__VITE_ASSET__BwpebYAu__"